// Process timeline — 4 stages.

const IMG = {
    blueprint: "blueprint",
    design: "architectural",
    install: "network_rack",
    concierge: "living_room",
};

export const PROCESS_STAGES = [
    {
        number: "01",
        title: "Discovery",
        lede:
            "Every engagement begins with listening. We meet on-site, often before drawings are finalized, with the principal, architect, and interior designer.",
        copy:
            "We learn the cadence of the household — when mornings begin, where music belongs, which rooms are private and which are public. Discovery yields a written control narrative that is reviewed across the design team before a single cable is specified. Nothing is assumed; nothing is templated.",
        bullets: [
            "On-site walkthroughs with the architectural and interior teams",
            "Written control narrative reviewed and signed by the principal",
            "Confidentiality from the first conversation, every conversation",
        ],
        image: IMG.blueprint,
    },
    {
        number: "02",
        title: "Design",
        lede:
            "Design is where opinion becomes specification. We draft schematics, scenes, and bespoke interfaces alongside your design team — on paper before we ever touch a wire.",
        copy:
            "Platforms are selected for the residence, not the contractor. Keypad finishes are coordinated with millwork; rack locations with mechanical; cable pathways with electrical. We deliver a complete design package — drawings, scenes, schedules, and a bill of materials — that the architect can hold, the GC can build to, and the principal can read.",
        bullets: [
            "Platform selection (Control4, Savant, Lutron) based on residence and not preference",
            "Bespoke keypad layouts, scene libraries, and room-by-room schedules",
            "Coordination drawings issued to the GC, electrical, and mechanical trades",
        ],
        image: IMG.design,
    },
    {
        number: "03",
        title: "Installation",
        lede:
            "Installation is a long, quiet, choreographed dance with the trades on site. We arrive with our own field team and our own standards.",
        copy:
            "Pre-wire, rough-in, finish, and commissioning are each treated as discrete milestones with sign-off. Our technicians arrive in shoe covers; tools are organized; cable is dressed; every termination is labeled and photographed. By the time the principal walks the home, the system is silent — present in service of the room, never in front of it.",
        bullets: [
            "Phased trade coordination with weekly site walks and written sign-offs",
            "In-house, certified technicians (we do not subcontract integration)",
            "ISF and acoustic calibration with measurement microscopy on every theater",
        ],
        image: IMG.install,
    },
    {
        number: "04",
        title: "Concierge",
        lede:
            "The work does not end at handoff. The relationship begins there. Every ACT residence enters lifetime stewardship from the day of occupancy.",
        copy:
            "A dedicated concierge — known to the household, named in your contract — is the single point of contact for the family and staff. We monitor proactively, push firmware on a tested cadence, and review the system seasonally. When something needs attention, we call you; you do not call us. Our oldest installations remain in service more than two decades on.",
        bullets: [
            "Proactive 24/7 monitoring with silent remediation",
            "Quarterly stewardship reviews with the principal and household staff",
            "A direct line to engineering — no ticket, no queue, no escalation",
        ],
        image: IMG.concierge,
    },
];
